import { useEffect, useRef } from 'react';

export function useDidUpdate(fn: () => void, dependencies?: any[]) {
  const mounted = useRef(false);

  // Reset on unmount so StrictMode's simulated remount isn't treated as an update.
  useEffect(
    () => () => {
      mounted.current = false;
    },
    []
  );

  useEffect(() => {
    if (mounted.current) {
      fn();
    } else {
      mounted.current = true;
    }
  }, dependencies);
}
